import { clone, cloneDeep } from "lodash-es";

export class CloneHelper {
  public static cloneShallow<T = any>(value: T): T {
    return clone(value);
  }

  public static cloneDeep<T = any>(value: T): T {
    return cloneDeep(value);
  }
}
